import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  expandedDetail: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
});
